"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoClosureRequestStatus = void 0;
var PoClosureRequestStatus;
(function (PoClosureRequestStatus) {
    PoClosureRequestStatus["PENDING"] = "PENDING";
    PoClosureRequestStatus["SUCCEEDED"] = "SUCCEEDED";
    PoClosureRequestStatus["FAILED"] = "FAILED";
    PoClosureRequestStatus["ALREADY_CLOSED"] = "ALREADY_CLOSED";
})(PoClosureRequestStatus || (exports.PoClosureRequestStatus = PoClosureRequestStatus = {}));
